"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaterialColorsController = function () {
  function MaterialColorsController(ProductsDataProvider, ProductPartsDataProvider, $stateParams) {
    "ngInject";

    (0, _classCallCheck3.default)(this, MaterialColorsController);
    this.ProductsDataProvider = ProductsDataProvider;
    this.ProductPartsDataProvider = ProductPartsDataProvider;

    var product = ProductsDataProvider.products.findOne({ slug: $stateParams.product }),
        materials = product.materials,
        material = materials.find(function (material) {
      return material.slug == $stateParams.material;
    }),
        productColors = material.spec.colors,
        allColors = ProductPartsDataProvider.colors.find({}).map(function (color) {
      return (0, _assign2.default)({}, color);
    });

    allColors.forEach(function (color) {
      color.assigned = productColors.some(function (productColor) {
        return color.id == productColor.id;
      });
    });

    this.colors = allColors;
    this.product = product;
    this.material = material;
    this.filterState = "assigned";
  }

  (0, _createClass3.default)(MaterialColorsController, [{
    key: "filter",
    value: function filter(colors) {
      switch (this.filterState) {
        case 'assigned':
          return colors.filter(function (color) {
            return color.assigned == true;
          });
        case 'unassigned':
          return colors.filter(function (color) {
            return color.assigned != true;
          });
        case 'all':
          return colors;
        default:
          throw new Error("unsupported filter type for colors");
      }
    }
  }, {
    key: "setFilterState",
    value: function setFilterState(value, $event) {
      if ($event) {
        $event.preventDefault();
      }
      this.filterState = value;
    }
  }, {
    key: "changeColorAssigment",
    value: function changeColorAssigment(color, $event) {
      $event.preventDefault();
      color.__loading = true;
      var actionName = '';
      if (color.assigned) {
        actionName = 'deleteProductMaterialColor';
      } else {
        actionName = 'addProductMaterialColor';
      }
      this.ProductsDataProvider[actionName](this.product.id, this.material.id, color.id).then(function (responseColor) {
        delete color.__loading;
        color.assigned = !color.assigned;
      });
    }
  }, {
    key: "toggleCustomColors",
    value: function toggleCustomColors($event) {
      $event.preventDefault();
      this.customColors = !this.customColors;
    }
  }, {
    key: "updateName",
    value: function updateName(color, $event) {
      $event.preventDefault();
      color.__loading = true;
      //color.slug=this.onvertToSlug(color.name);    
      this.ProductsDataProvider['updateName'](color, 2).then(function (responseShape) {
        delete color.__loading;
      });
    }
  }, {
    key: "onvertToSlug",
    value: function onvertToSlug(text) {
      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
    }
  }]);
  return MaterialColorsController;
}();

// WEBPACK FOOTER //


exports.default = MaterialColorsController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-color-spec/controller.js
 **/